/**
 * Format the number into currency using Intl.NumberFormat
 *
 * @param {Number} number
 * @param {String} currency
 * @returns {String}
 */
export default function currencyFormatter(number, currency = "inr") {
  return new Intl.NumberFormat(currency === "inr" ? "en-IN" : "en-US", {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(number)
}